import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";

interface CertificateWebhookPayload {
    requestId: string;
    colabCorpCode: string;
    userName: string;
    certType: string;
    date: string;
    rolCorp: string;
    colabDniCode: string;
    userEmail: string;

}

const getWorkerProfile = async (userId: string) => {
    const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
    const collectionId = import.meta.env.VITE_WORKER_PROFILE_COLLECTION_ID;

    const response = await databases.listDocuments(databaseId, collectionId, [
        Query.equal("userId", userId)
    ]);

    if (response.documents.length === 0) throw new Error("Perfil no encontrado");
    return response.documents[0];
};

export const sendCertificateToN8n = async (
    requestId: string,
    userId: string,
    userName: string,
    certType: string,
    userEmail: string,
): Promise<{ success: boolean; error?: string }> => {
    const N8N_WEBHOOK_URL = import.meta.env.VITE_N8N_WEBHOOK_CREATE_EMPLOYMENT_CERTIFICATE_URL;

    // if (!N8N_WEBHOOK_URL) return { success: false, error: 'Webhook URL no encontrada' };

    try {
        const profile = await getWorkerProfile(userId);

        const payload: CertificateWebhookPayload = {
            requestId,
            colabCorpCode: profile.colabCorpCode || '',
            userName,
            userEmail,
            certType,
            date: new Date().toISOString(),
            rolCorp: profile.rolCorp || '',
            colabDniCode: profile.colabDniCode || '',
        };

        const response = await fetch(N8N_WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!response.ok) return { success: false, error: `HTTP ${response.status}` };

        return { success: true };
    } catch (error) {
        return { success: false, error: error instanceof Error ? error.message : 'Error desconocido' };
    }
};

